window.SignatureForm = function(scope) {
    var self = this;
    var formName = "signature-form";
    self.name = formName;
    var _protected = BaseForm.call(self, formName, scope);

    self.load = function() {};

    self.onCheckClicked = function (value) {
    };

    self.save = function() {
        var defer = $q.defer();

        defer.resolve();

        return defer.promise;
    };

    self.load();
}
